import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
  },
  chip: {
    borderColor: theme.palette.dai.light,
    backgroundColor: theme.palette.dai.lightBlue,
    color: theme.palette.dai.dark,
    fontWeight: 500,
    textTransform: 'none',
    fontSize: theme.typography.pxToRem(12),
    '& .MuiChip-label': {
      textTransform: 'none',
      fontSize: theme.typography.pxToRem(12),
    },
    '&:hover, &:focus': {
      backgroundColor: theme.palette.dai.light,
    },
  },
}))

export default useStyles
